<button
  sdButton
  class="delivery-add-address text-b3-s-500"
  type="primary"
  [fullWidth]="true"
  (click)="openModal()"
  data-testid="changeDelivery"
>
  <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.MAP_LOCATION"></sd-icon>
  {{ text() }}
</button>
